import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faListOl,
} from "@fortawesome/free-solid-svg-icons";

const Vitalicia = () => {
  return (
    <div id="watermark" className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md={8} className="text-center">
            <h1 className="mb-3">Activa tu Suscripción de Largo Plazo</h1>
            <p className="lead">
              Para activar tu suscripción de largo plazo debes realizar el
              proceso directamente con nuestro equipo.
            </p>
            <p>
              Sigue los pasos a continuación para completar la activación de tu
              suscripción.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center mb-5">
          <Col md={7}>
            <Card className="shadow-sm">
              <Card.Body>
                <h4 className="mb-4 text-center">
                  <FontAwesomeIcon icon={faListOl} className="me-2" />
                  Pasos para Activar tu Suscripción
                </h4>

                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>1. Contacta a nuestro equipo</strong>
                    <div className="text-muted">
                      Escríbenos por WhatsApp o correo electrónico indicando que
                      deseas activar una suscripción de largo plazo.
                    </div>
                  </ListGroup.Item>

                  <ListGroup.Item>
                    <strong>2. Recibe tu enlace de pago</strong>
                    <div className="text-muted">
                      Nuestro equipo te enviará un enlace seguro para realizar
                      el pago de la suscripción.
                    </div>
                  </ListGroup.Item>

                  <ListGroup.Item>
                    <strong>3. Confirmación del pago</strong>
                    <div className="text-muted">
                      Una vez aprobado el pago, recibirás un código de
                      activación.
                    </div>
                  </ListGroup.Item>

                  <ListGroup.Item>
                    <strong>4. Ingresa tu código</strong>
                    <div className="text-muted">
                      Introduce el código recibido en la plataforma para activar
                      tu suscripción de largo plazo.
                    </div>
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-center text-center">
          <Col md={6}>
            <p className="fw-bold mb-4">Contáctanos para iniciar el proceso</p>

            <p>
              <FontAwesomeIcon icon={faPhone} className="me-2" />
              <a href="https://wa.me/+573142771096">(+57) 314 277 1096</a>
              <br />
              <a href="tel:+573164725531">(+57) 316 472 5531</a>
            </p>

            <p>
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              <a href="mailto:aureamedicina2020@gmail.com">
                aureamedicina2020@gmail.com
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Vitalicia;
